import { FunctionComponent, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../redux/features/auth/authSlice";
import TopNavBar from "../../components/nav/TopNavBar";
import { AppDispatch } from "../../redux/store";

const ResetPassword: FunctionComponent = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get("token");
  const userId = query.get("userId");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    const resetPasswordData = {
      newPassword,
      resetPasswordToken: token || "",
    };

    try {
      const resultAction = await dispatch(
        resetPassword({ dto: resetPasswordData, userId: userId || "" })
      );
      if (resetPassword.fulfilled.match(resultAction)) {
        navigate("/reset-password-success");
      } else {
        throw new Error("Password reset failed");
      }
    } catch (error) {
      setErrorMessage(
        "Password reset failed. Check if your link expired or try again later"
      );
    }
  };

  return (
    <div className="w-full relative shadow-[0px_0px_124px_-15px_rgba(0,_0,_0,_0.25)] rounded-8xs bg-background-grey h-screen overflow-hidden flex flex-col items-center justify-start gap-[50px] sm:gap-[30px]">
      <TopNavBar />
      <main className="w-[90%] max-w-[580px] rounded-[20.49px] bg-white h-[70%] overflow-hidden shrink-0 flex flex-col items-center justify-between pt-[20px] px-4 pb-0 box-border mix-blend-normal text-center text-11xl text-dimgray-200 font-inter sm:w-full sm:h-auto sm:rounded-none sm:pt-[10px]">
        <div className="w-[90%] max-w-[480px] flex flex-col items-center justify-start gap-[15px] sm:gap-[10px]">
          <img
            className="w-[80px] sm:w-[60px] relative h-[80px] object-cover"
            alt=""
            src="/logo/logo.png"
          />
          <h1 className="m-0 w-full relative text-inherit font-medium font-inherit flex items-center justify-center">
            Reset Password
          </h1>
        </div>
        <div className="w-[90%] max-w-[480px] flex-1 flex flex-col items-center justify-center gap-[15px] text-left text-sm-7 sm:w-full">
          <div className="self-stretch flex flex-col items-start justify-start gap-[3.4px]">
            <div className="relative">New Password</div>
            <input
              className="[outline:none] bg-[transparent] self-stretch relative rounded-[10.24px] box-border h-[47.8px] overflow-hidden shrink-0 border-[0.9px] border-solid border-dimgray-500"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-[3.4px]">
            <div className="relative">Confirm New Password</div>
            <input
              className="[outline:none] bg-[transparent] self-stretch relative rounded-[10.24px] box-border h-[47.8px] overflow-hidden shrink-0 border-[0.9px] border-solid border-dimgray-500"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <button
            className="cursor-pointer p-[15px] bg-button-blue self-stretch rounded-3xs flex flex-row items-center justify-center"
            onClick={handleSubmit}
          >
            <div className="relative text-xl-2 font-semibold font-inter text-white text-left">
              Reset Password
            </div>
          </button>
          {errorMessage && (
            <div className="mt-4 text-blue-500 text-center">{errorMessage}</div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ResetPassword;
